import {payValidationOptions} from "./payValidationOptions";
import {buyValidationOptions} from "./buyValidationOptions";

function thisIsPayApp() {
    return $(".paymentForm").length > 0;
}

let appValidationOptions = {}

if (thisIsPayApp()) {
    appValidationOptions = payValidationOptions;
} else {
    appValidationOptions = buyValidationOptions;
}

export default appValidationOptions;
